import { Redo, Undo } from 'lucide-react';

import { cn } from 'components/lib/utils';
import { Tooltip, TooltipContent, TooltipPortal, TooltipTrigger } from 'components/ui/tooltip';

import { useFormHistory } from './useFormHistory';

export const FormControllers: React.FC = () => {
  const { canUndo, canRedo, undo, redo } = useFormHistory();

  return (
    <div className="flex gap-0.5 select-none">
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className={cn(
              'w-9 h-9 flex justify-center items-center rounded-md',
              canUndo
                ? 'cursor-pointer hover:bg-neutral-100 text-indigo-600'
                : 'cursor-default text-base-sidebarRing'
            )}
            onClick={canUndo ? undo : undefined}
          >
            <Undo size={16} />
          </div>
        </TooltipTrigger>
        <TooltipPortal>
          <TooltipContent className="z-[1100]">
            <p className="bg-[#71717A] text-white text-xs px-2 py-1 rounded-md">
              Undo
            </p>
          </TooltipContent>
        </TooltipPortal>
      </Tooltip>

      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className={cn(
              'w-9 h-9 flex justify-center items-center rounded-md',
              canRedo
                ? 'cursor-pointer hover:bg-neutral-100 text-indigo-600'
                : 'cursor-default text-base-sidebarRing'
            )}
            onClick={canRedo ? redo : undefined}
          >
            <Redo size={16} />
          </div>
        </TooltipTrigger>
        <TooltipPortal>
          <TooltipContent className="z-[1100]">
            <p className="bg-[#71717A] text-white text-xs px-2 py-1 rounded-md">
              Redo
            </p>
          </TooltipContent>
        </TooltipPortal>
      </Tooltip>
    </div>
  );
};
